export function formatTag(tag: string) {
  return tag.toLowerCase();
}
